"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  booking: {
    bookingJapan: {
      customerCode: 'Customer Code',
      customerNameCn: 'Customer Name Cn',
      customerName: 'Customer Name En',
      POR: 'POR',
      DEL: 'DEL',
      radioDirect: 'Direct ',
      radioTS: 'T/S',
      POLETD: 'POL ETD',
      PODETA: 'POD ETA',
      searchButton: 'Search',
      UsageMethod: 'Usage Method',
      UsageMethodText1: 'It will display the results accroding to the conditions including POL、POD、ETD(A)、SERVICE TYPE',
      UsageMethodText2: 'Booking directly from query results',
      ShippingScheduleInquiry: 'Shipping Schedule Inquiry',
      ShippingScheduleInquiryText1: 'Please query shipping schedule according to POL、POD、ETD(A)、SERVICE TYPE',
      ShippingScheduleInquiryText2: 'ETD、ETA、SERVICE TYPE are not not-empty control',
      Results: 'Results',
      ResultsText: 'Display vessel/voy in order of date',
      Booking: 'Booking',
      BookingText1: 'Click on [booking] button, switch to booking interface, please click on [send] after inputting information',
      BookingText2: 'Staff of SITC JAPAN will contact to you as soon as possible.',
      Scheduleresults: 'Schedule results',
      FilterByVessel: 'Filter By Vessel',
      FilterByLane: 'Filter By Lane',
      BookingButton: 'Booking',
      POL: 'POL',
      POD: 'POD',
      bookingStatus: 'Status',
      CREATEDTIME: 'CREATED TIME',
      From: 'From',
      To: 'To',
      BKGNO: 'BKG NO',
      BLNO: 'B/L NO.',
      exportButton: 'Export',
      historyInfo1: 'We upload the freight memo around 9 AM on the ETD , and send to you by fax or mail if you select a checkmark at booking. An icon (￥) will appear on the right side of the BK No.',
      historyInfo2: 'you can print or download it by clicking the icon (￥).BKG NO. is temporary while the status is Waiting or Pending, and it becomes confirmed once the status changes to Approved.',
      BookingHistory: 'Booking History',
      statusTable: 'STATUS',
      actionTable: 'ACTION',
      BkgNoTable: 'BKG NO.',
      billTypeTable: 'BILL TYPE',
      blNotable: 'B/L NO.',
      vesselNameTable: 'VESSEL NAME',
      voyNoTable: 'VOY NO',
      polTable: 'POL',
      etaTable: 'ETA',
      etdTable: 'ETD',
      podTable: 'POD',
      deltable: 'DEL',
      portAgentNameTable: 'Port Agent Name',
      TerminalNameTable: 'Terminal Name',
      UpdateTimeTable: 'UPDATE TIME',
      polWarning: 'The POR cannot be empty',
      podWarning: 'The DEL cannot be empty',
      selectWarning: 'Please select at least one voyage!',
      resetButton: 'Reset',
      etdStrWarning: 'The departure time cannot be empty',
      No: 'No',
      bookingHeadWebIdTable: 'bookingHeadWebId',
      feeFlagTable: 'feeFlag',
      lockStatusTable: 'lockStatus',
      voyageLegTable: 'voyageLeg',
      vesselCodeTable: 'vesselCode',
      ccaNoTable: 'ccaNo',
      freightMemoTable: 'Freight Memo',
      tt3Table: 'tt3',
      submitTable: 'Submit',
      viewTable: 'View',
      changeTable: 'Change',
      cancelTable: 'Cancel',
      copyTable: 'Copy',
      vesselName: 'VESSEL Name',
      voyageNo: 'VOY NO',
      usedHours: 'Sailling',
      serviceLineCode: 'Lane',
      xEnglishInfo: 'X　: Booking unacceptable',
      port: 'PORT NAME'
    },
    bookingTemplate: {
      modelName: 'Template Name',
      Portofdeparture: 'POR',
      Destinationport: 'DEL',
      Bookingcontainertype: 'Booking container type',
      createTime: 'Create Time',
      resetButton: 'Reset',
      searchButton: 'Search',
      addTemplateButton: 'Add Template',
      deleteSuccess: 'Delete Success',
      deleteConfirm: 'Confirm deletion?',
      deletTip: 'Tip',
      bookingButton: 'Booking Now',
      editTemplateButton: 'Modify',
      deleteTemplateButton: 'Delete'
    },
    bookingSplit: {
      applyBooking: 'Applying',
      vesselName: 'Vessel Name',
      splistWanning3: 'Sub-reporting of split tickets does not allow for re-sub-reporting of split tickets.',
      splistWanning4: 'Submission of a report and separation request is not accepted for splitting and consolidation orders.',
      splistWanning5: 'This order is a sub-ledger and sub-ledger master order, and cannot be split or merged.',
      splistWanning6: 'Split single split ticket does not allow re-split ticket。',
      spliteTitle0: 'Split BL',
      spliteTitle1: 'Combine BL',
      spliteTitle3: 'Split Booking',
      splistWanningBooking: 'Only bills of lading with confirmed booking, unlocking, and splitting application status are supported for splitting and splitting operations',
      splistCNSHA: 'This function is only for CNSHK, CNNSA and Thailand',
      splistCntFlag: 'Only ACCEPTED / BKG UNLOCKED / SPLIT APPLYING status and this BL is not contain container details can be Quick Split',
      splistMain1: 'Only "B/L OP Mode = Normal BL " OR " B/L OP Mode = SPLIT BL AND B/L Type = TOP BL " can be  Quick Split',
      splistCntFlag2: 'Only ACCEPTED / BKG UNLOCKED / COMBINE APPLYING status and this BL is not contain container details can be Quick Combine',
      splistMain2: 'Only ACCEPTED / BKG UNLOCKED / COMBINE APPLYING status and this BL is not contain container details can be Quick Combine',
      spliteCombinType0: 'Quick Spllit',
      spliteCombinType1: 'Quick Combine',
      splistWanningBooking1: 'Only "B/L OP Mode = Normal BL " OR " B/L OP Mode = SPLIT BL AND B/L Type = TOP BL " can be split',
      repeatWarning1: ' bkNo:',
      repeatWarning2: 'already exist please re-enter',
      splistWanning10: 'Only ACCEPTED / BKG UNLOCKED / COMBINE APPLYING status and this BL is not contain container details can be Quick Combine',
      splistChildrenWarning0: 'Only "B/L OP Mode = Normal BL " OR " B/L OP Mode = SPLIT BL AND B/L Type = TOP BL " can be  Quick Split',
      splistChildrenWarning1: 'Only ""B/L OP Mode = Normal BL "" OR "" B/L OP Mode = COMBINE BL AND B/L Type = TOP BL "" can be Quick Combine',
      repeatWarningBlNo1: 'blNo:',
      repeatWarningBlNo2: 'already exist please re-enter',
      splistWanningType3: 'Only "B/L OP Mode = Normal BL " OR " B/L OP Mode = COMBINE BL AND B/L Type = TOP BL " can be combined.',
      reportOutWarning: 'nly ACCEPTED / BKG UNLOCKED / SPLIT APPLYING status and this BL is not contain container details can be Quick Split',
      reportOutOneWarning: 'Only ACCEPTED / BKG UNLOCKED / SPLIT APPLYING status and this BL is not contain container details can be Quick Split',
      splitWarningOut1: 'Only ACCEPTED / BKG UNLOCKED / SPLIT APPLYING status can be split',
      splitWarningOut2: 'Only ACCEPTED / BKG UNLOCKED / COMBINE APPLYING status can be  combined',
      cancelWarning0: 'Only  B/L OP Mode = SPLIT BL AND B/L Type = TOP BL  can be cancel split',
      cancelWarning1: 'Only  B/L OP Mode = COMBINE BL AND B/L Type = TOP BL  can be cancel combine',
      cancelWarning3: 'Only B/L iS  SUB REPORTED TOP BL " can be cancel reported',
      splitDataValidateTh: 'International transit shipment from China to other countries cannot be split BL.'
    },
    bookingHistroyJp: {
      customsBrokerWarning: "Company Name can not be empty!  <br/>" + "The information of Volume cannot be empty such as Gross Weight, Size, Quantity, Cargo Group etc.<br/>" + "Cargo Commodity can not be empty!",
      commodityCodeWaring: "The information of Volume cannot be empty such as Gross Weight, Size, Quantity, Cargo Group etc.<br/>" + "Cargo Commodity can not be empty!",
      grossWeightWarning: "Volume FCL Gross Weight can not be empty!<br/>" + "Cargo Commodity can not be empty!",
      cargoDescWarnng: 'Cargo Commodity can not be empty!',
      isSubmit: 'Apply Booking?',
      applyDownloadWarning: 'Please choose the record.',
      applyDownloadWarning2: 'BK NO.:',
      applyDownloadWarning3: "<br/>Thers is no freight , please check.",
      webBkImosWarning: 'Hazardous Cargo can not be empty!',
      // webBkImosWarning: `Hazardous Cargo can not be empty!<br/>` +
      //   `Consignee Name can not be empty!`,
      webBkReefersWarning: 'Reffer can not be empty!',
      webBkAksWarning: 'Awkward Container can not be empty!',
      deliveryDocumentCompanyWarning: 'Consignee Name can not be empty!',
      cancenConfirm: 'Cancel Booking?'
    },
    bookingHistroryJpDetails: {
      PortofReceipt: 'Port of Receipt:',
      POL: 'POL:',
      POD: 'POD:',
      PortofDelivery: 'Port of Delivery:',
      VESSELVOYAGE: 'VESSEL VOYAGE:',
      POLETA: 'POL ETA:',
      POLETD: 'POL ETD:',
      PODETA: 'POD ETA',
      Shipper: 'Shipper',
      Volume: 'Volume',
      HazardousCargo: 'Hazardous Cargo',
      DGList: 'D.G. List',
      Payment: 'Payment',
      ApproveKey: 'Approve Key',
      ContactTypeCode: 'Contact Type Code',
      ContactName: 'Contact Name',
      ContactNumber: 'Contact Number',
      Vent: 'Vent',
      Temperature: 'Temperature',
      Size: 'Size',
      saveSuccess: 'Save Success',
      submitSuccess: 'Submit Success',
      dangerInfoTips: '(If need combined shipment, please input the detail information in the remark region.)',
      draftSaveButton: 'Draft Save',
      confirmButton: 'Confirm',
      backButton: 'Back',
      submitButton: 'Submit',
      companyNameInfo: 'Company Name:',
      telInfo: 'Tel:',
      e_mailInfo: 'E-Mail:',
      contactInfo: 'Contact:',
      faxInfo: 'Fax:',
      bookingDetailTitle: 'Booking Detail',
      faxNotNull: 'Fax can not be empty!'
    },
    blAgreementFr: {
      blNo: 'B/L NO.',
      ctnNo: 'BKG With Cntr',
      appStatus: 'Apply Status',
      active: 'Active',
      freightCode: 'Agreement No.',
      vvl: 'Vessel Agreement',
      applyNo: 'FT Apply No',
      applyStatusFt: 'FT Apply Status',
      activeFt: 'FT Active',
      vvlFt: 'FT Vessel',
      applyDays: 'Apply Days',
      demuFreeDays: 'Apply Days/DEM',
      detenFreeDays: 'Apply Days/DET',
      manifestNoFt: 'Approval No.',
      paidType: 'PayType',
      socCheckFlag: 'SOC',
      manifestNo: 'Manifest No.',
      fwd: 'Forwarder',
      vesselAndVoyageOrBlNoNotNull: 'VVL/BL NO can not be empty!'
    }
  }
};